module.exports = __webpack_public_path__ + "img/Occupation-low.cd307c99.jpg";